<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">

      <template slot="left" >
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-tools</v-icon>{{$t('profile.tool.heaters')}}</h1>
        </v-toolbar-title>
      </template>




    </Toolbar>
    <ToolHeaterForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import ToolHeaterForm from '../../components/toolheater/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'ToolHeater';

const { mapFields } = createHelpers({
  getterType: 'toolheater/getField',
  mutationType: 'toolheater/updateField'
});

export default {
  name: 'ToolHeaterCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    ToolHeaterForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('toolheater', ['create', 'reset'])
  }
};
</script>
